import { useAtom } from "jotai";
import { QuestionnaireStepperPercentageStore } from "../stores/questionnaireStepperPercentageStore";

export function useQuestionnaireStepperPercentage() {
  const [currentPercentage, setCurrentPercentage] = useAtom(QuestionnaireStepperPercentageStore);

  return {
    currentPercentage: currentPercentage.currentPercentage,
    setCurrentPercentage,
  };
}
